// import './App.scss';
import TopBar from './components/TopBar.js'
import AboutUs from './components/AboutUs.js'
import Carusel from "./components/Carusel.js";
import Project from "./components/Project.js";
import HomePage from './components/pages/HomePage.js';
import Description from './components/Description.js'
import ContactUs from "./components/ContactUs";
import Navbar from './components/Navbar.js';
import Team from "./components/Team";
import ToTopButton from "./components/ToTopButton";
import LoggedIn from './components/LoggedIn.js';
import Footer from "./components/Footer";
import Features from "./components/Features.js";
import {useAuth0} from "./react-auth0-spa";
import { Routes, Route } from 'react-router-dom';
import ContactPage from './components/pages/ContactPage'

import './scss/bootstrap.scss'
import MethodologyPage from "./components/pages/MethodologyPage";
import ProductPage from "./components/pages/ProductPage";


function App() {
    const {isAuthenticated} = useAuth0();
    const {loading} = useAuth0();

    // if (loading) {
    //     return <div>Loading ...</div>
    // }

    return (
        <div className="App">
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="about" element={<ContactPage />} />
                <Route path="project" element={<ProductPage />} />
                <Route path="service" element={<ContactPage />} />
                <Route path="methodology" element={<MethodologyPage />} />
            </Routes>
            {/*<TopBar></TopBar>*/}
            {/*<Navbar></Navbar>*/}
            {/*<Carusel></Carusel>*/}
            {/*<AboutUs></AboutUs>*/}
            {/*<Features></Features>*/}
            {/*<Project></Project>*/}
            {/*<Description></Description>*/}
            {/*<ContactUs></ContactUs>*/}
            {/*<Team></Team>*/}
            {/*<Footer></Footer>*/}

            {/*<ToTopButton></ToTopButton>*/}
            {/*{!isAuthenticated && (<HomePage/>)}*/}
            {/*{isAuthenticated && <LoggedIn/>}*/}
        </div>
    );
}

export default App;
